export default __webpack_public_path__ + "static/desktop-app-desktop-a81fa230e37e67af7443e93bdd97568f.png";